// extracted by mini-css-extract-plugin
export var border = "IntroHeroWithSubheading-module--border--87b17";
export var bordersection = "IntroHeroWithSubheading-module--bordersection--b1768";
export var herowithimagecontainer = "IntroHeroWithSubheading-module--herowithimagecontainer--d905f";
export var subheading = "IntroHeroWithSubheading-module--subheading--189c1";
export var textcontainer = "IntroHeroWithSubheading-module--textcontainer--3c594";
export var title = "IntroHeroWithSubheading-module--title--a6339";
export var topsectionouter = "IntroHeroWithSubheading-module--topsectionouter--ad800";